import React from 'react';

import { useUIContext } from 'lib/context/UIContext/UIContext';

import Dot from 'components/shared/Dot/Dot';
import Typography from 'components/shared/Typography/Typography';

const DetailsCell = ({ data }) => {
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';
  const { details = '', type, procedure_code, diagnosis_code } = data || {};

  if (isMobile) {
    return (
      <div className="flex w-full flex-col gap-1">
        <Typography variant="label" size="medium" weight="medium">
          {details}
        </Typography>
        <div className="flex items-center gap-1.5">
          {procedure_code && (
            <>
              <Typography variant="p" size="xs" weight="medium" color="neutral-700">
                {procedure_code}
              </Typography>
            </>
          )}
          {diagnosis_code && (
            <>
              <Dot size="xs" color="neutral" className="!bg-transparent shadow-none" />
              <Typography variant="p" size="xs" weight="medium" color="neutral-700">
                {diagnosis_code}
              </Typography>
            </>
          )}
          {type && (
            <>
              <Dot size="xs" color="neutral" className="!bg-transparent shadow-none" />
              <Typography variant="p" size="xs" weight="medium" color="neutral-700">
                {type}
              </Typography>
            </>
          )}
        </div>
      </div>
    );
  }
  return (
    <div className="flex min-w-52 flex-col gap-1 px-2">
      <Typography variant="label" size="medium" weight="medium">
        {details}
      </Typography>
      <div className="flex items-center gap-1.5">
        {type && (
          <>
            <Typography
              variant="p"
              size="xs"
              weight="medium"
              color="neutral-700"
              className="whitespace-nowrap">
              {type}
            </Typography>
          </>
        )}
      </div>
    </div>
  );
};

export default DetailsCell;
